import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';

// const API_BASE = '/api-career';

@Injectable({ providedIn: 'root' })
export class ApiPrefixInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const alreadyPrefixed = req.url.startsWith('http');
    const url = alreadyPrefixed ? req.url : `${req.url}`;
    const clonedRequest = alreadyPrefixed ? req : req.clone({ url });
    return next.handle(clonedRequest);
  }
}
